import { createContext, useContext, useMemo } from "react";

/*
const images = [
  "1-1.webp",
  "1-2.webp",
  "1-3.webp",
  "1-4.webp",
  "1-5.webp",
  "1-6.webp",
  "3-1.webp",
  "3-2.webp",
  "3-3.webp",
  "3-4.webp",
  "3-5.webp",
  "3-6.webp",
  "4-1.webp",
  "4-2.webp",
  "4-3.webp",
  "4-4.webp",
  "4-5.webp",
  "4-6.webp",
];
*/
/** 處理CloudFlareCaptcha的Service */
export interface ICaptchaService {
  /** 開啟驗證器Dialog */
  // openCaptchaDialog: () => void;
}
const Context = createContext<ICaptchaService>(null);

export function useCaptchaService() {
  const context = useContext(Context);
  if (!context) {
    throw new Error("useCaptchaService 必須在CaptchaService之下層執行！");
  }
  return context;
}

export const CaptchaService = ({ children }) => {

  /*
  // 外部依賴區 
  const { CloseCFWindow } = useCommonApi()
  const { setBlockUI } = useLoading()

  // 內部狀態區
  const [questions, setQuestions] = useState<Array<string>>()
  const [_dialogOpen, _setDialogOpen] = useState<boolean>(false)
  const [answer, setAnswer] = useState<string>()

  const openCaptchaDialog = useCallback(() => {
    const questions = _.sampleSize(images, 9);
    const answer = _.sample(questions)
    setAnswer(answer)
    setQuestions(questions)
    _setDialogOpen(true)

  }, [_setDialogOpen])

  const onImageClick = useCallback(async (image) => {
    console.log(image, answer)
    if (answer === image) {
      setBlockUI('blockUI')
      try {
        await CloseCFWindow();
        _setDialogOpen(false)
      } finally {
        setBlockUI()
      }
    } else {
      openCaptchaDialog()
    }
  }, [CloseCFWindow, answer, openCaptchaDialog, setBlockUI])
*/
  const context = useMemo(() => ({
    //openCaptchaDialog
  }), [])

  return <Context.Provider value={context}>
    {children}
  </Context.Provider>
  /*
  return <Context.Provider value={context}>
    {children}
    <Dialog open={_dialogOpen} noOutside>

      <div className="flex flex-direction:column gap:16">
        <h1>Captcha</h1>
        <br />
        <div>
          Plase select
          <img
            className="width:64px height:64px padding:8px"
            alt="captcha-question"
            src={`/assets/imgs/lottery/${answer}`}
          />
          from following images.
        </div>
        <div className="grid-cols:3 flex-wrap:wrap gap:8">
          {questions?.map((q, index) =>
            <img onClick={() => onImageClick(q)}
              key={`ans-${q}`}
              alt="captcha-answer"
              className="width:96px height:96px cursor:pointer"
              src={`/assets/imgs/lottery/${q}`} />
          )}
        </div>
      </div>
    </Dialog>
  </Context.Provider>;
  */
};
